<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_3"></a><strong>T<span class="small">HE</span> P<span class="small">URPOSE</span>-G<span class="small">UIDED</span> U<span class="small">NIVERSE</span></strong></h1>
<p class="subtitle">B<span class="small">ELIEVING IN</span> E<span class="small">INSTEIN</span>, D<span class="small">ARWIN, AND</span> G<span class="small">OD</span></p>
<p class="author">BERNARD HAISCH</p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1ddda401